import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  toString1pkumu07cwy4m as toString,
  hashCodeq5arwsb9dgti as hashCode,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  equals2au1ep9vhcato as equals,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  _ReactiveState___get_raw__impl__92ipya10f5f3x6hwqt0 as _ReactiveState___get_raw__impl__92ipya,
  _ReactiveState___init__impl__fvdp9b2eqyidpf491cp as _ReactiveState___init__impl__fvdp9b,
  InternalReactiveWrapper6qytbrc1rcqv as InternalReactiveWrapper,
  Companion_getInstance1a6q7ejsqzzhs as Companion_getInstance,
  InternalReactiveThrownException1wn4fe03qbefg as InternalReactiveThrownException,
  InternalReactiveNotReady_instance37iasaqvolrrz as InternalReactiveNotReady_instance,
} from '../../../../../../reactive/com/lightningkite/reactive/core/ReactiveState.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { Frame1e7t2kcdb3wu7 as Frame } from './ContainingView.commonHtml.mjs';
import { get_centered1xfu6or5nc0lq as get_centered } from '../helpers.mjs';
import { ActivityIndicatork1oa7i2hevyv as ActivityIndicator } from './ActivityIndicator.commonHtml.mjs';
import { RawReactive253xb355brtjj as RawReactive } from '../../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { afterTimeout2ddqxaabn39mu as afterTimeout } from '../../afterTimeout.mjs';
import {
  listOfNotNull1v4ggfackvuny as listOfNotNull,
  emptyList1g2z5xcrvp2zy as emptyList,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { ImageScaleType_Fit_getInstanceowdhgt1q4kgg as ImageScaleType_Fit_getInstance } from '../../models/data.mjs';
import { firstOrNull1982767dljvdy as firstOrNull } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { _Duration___get_inWholeMilliseconds__impl__msfiry1byvgyrhm5g4a as _Duration___get_inWholeMilliseconds__impl__msfiry } from '../../../../../../kotlin-kotlin-stdlib/kotlin/time/Duration.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { RawImageViewZoomable3s4y58x72taln as RawImageViewZoomable } from './RawImageView.commonHtml.mjs';
import { reactive2pl1t9wy5gll5 as reactive } from '../../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import { CoroutineScopefcb5f5dwqcas as CoroutineScope } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var InfoClass;
function Info() {
  if (InfoClass === VOID) {
    class $ {
      constructor(sources, scaleType, description) {
        this.kdb_1 = sources;
        this.ldb_1 = scaleType;
        this.mdb_1 = description;
      }
      yd9(sources, scaleType, description) {
        return new (Info())(sources, scaleType, description);
      }
      ndb(sources, scaleType, description, $super) {
        sources = sources === VOID ? this.kdb_1 : sources;
        scaleType = scaleType === VOID ? this.ldb_1 : scaleType;
        description = description === VOID ? this.mdb_1 : description;
        return $super === VOID ? this.yd9(sources, scaleType, description) : $super.yd9.call(this, sources, scaleType, description);
      }
      toString() {
        return 'Info(sources=' + toString(this.kdb_1) + ', scaleType=' + this.ldb_1.toString() + ', description=' + this.mdb_1 + ')';
      }
      hashCode() {
        var result = hashCode(this.kdb_1);
        result = imul(result, 31) + this.ldb_1.hashCode() | 0;
        result = imul(result, 31) + (this.mdb_1 == null ? 0 : getStringHashCode(this.mdb_1)) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Info()))
          return false;
        if (!equals(this.kdb_1, other.kdb_1))
          return false;
        if (!this.ldb_1.equals(other.ldb_1))
          return false;
        if (!(this.mdb_1 == other.mdb_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Info');
    InfoClass = $;
  }
  return InfoClass;
}
function ZoomableImageView$refresh$lambda(this$0, $it) {
  return () => {
    this$0.odb_1.sba($it);
    return Unit_instance;
  };
}
function ZoomableImageView$refresh$lambda_0($$this$rawImageZoomable, this$0, $info) {
  return ($this$reactive) => {
    // Inline function 'com.lightningkite.reactive.core.ReactiveState.handle' call
    var this_0 = $this$reactive.daj($$this$rawImageZoomable.tcd_1);
    var tmp0_subject = _ReactiveState___get_raw__impl__92ipya(this_0);
    if (!equals(tmp0_subject, InternalReactiveNotReady_instance)) {
      if (tmp0_subject instanceof InternalReactiveThrownException()) {
        var it = _ReactiveState___get_raw__impl__92ipya(this_0).sah_1;
        if (equals(this$0.tdb_1, $info)) {
          this$0.vdb_1.eb7(0.0);
          this$0.wdb_1.pah(Companion_getInstance().uah(it));
        }
      } else {
        if (tmp0_subject instanceof InternalReactiveWrapper()) {
          var tmp = _ReactiveState___get_raw__impl__92ipya(this_0).rah_1;
          if (!(tmp == null ? true : !(tmp == null)))
            THROW_CCE();
          $$this$rawImageZoomable.eb7(1.0);
          if (equals(this$0.tdb_1, $info)) {
            this$0.vdb_1.eb7(0.0);
            this$0.wdb_1.pah(_ReactiveState___init__impl__fvdp9b($info));
          }
        } else {
          _ReactiveState___get_raw__impl__92ipya(this_0);
          $$this$rawImageZoomable.eb7(1.0);
          if (equals(this$0.tdb_1, $info)) {
            this$0.vdb_1.eb7(0.0);
            this$0.wdb_1.pah(_ReactiveState___init__impl__fvdp9b($info));
          }
        }
      }
    }
    return Unit_instance;
  };
}
function ActivityIndicator$_get_shown_$ref_61t2d1(p0) {
  return () => p0.wb8();
}
function ActivityIndicator$_set_shown_$ref_zcnirl(p0) {
  return (_this__u8e3s4) => {
    p0.hb7(_this__u8e3s4);
    return Unit_instance;
  };
}
var ZoomableImageViewClass;
function ZoomableImageView() {
  if (ZoomableImageViewClass === VOID) {
    class $ {
      constructor(viewWriter) {
        var tmp = this;
        // Inline function 'kotlin.with' call
        // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (Frame())(viewWriter.pc());
        var tmp0_elvis_lhs = viewWriter.cbb_1;
        var p = tmp0_elvis_lhs == null ? viewWriter : tmp0_elvis_lhs;
        viewWriter.ebb(p, view);
        viewWriter.fbb(p, view);
        tmp.odb_1 = view;
        this.pdb_1 = null;
        this.qdb_1 = false;
        this.rdb_1 = false;
        this.sdb_1 = false;
        this.tdb_1 = null;
        this.udb_1 = null;
        // Inline function 'kotlin.with' call
        var $this$with = this.odb_1;
        var tmp_0 = get_centered($this$with);
        // Inline function 'com.lightningkite.kiteui.views.direct.activityIndicator' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_0 = new (ActivityIndicator())($this$with.pc());
        var tmp0_elvis_lhs_0 = $this$with.cbb_1;
        var p_0 = tmp0_elvis_lhs_0 == null ? $this$with : tmp0_elvis_lhs_0;
        $this$with.ebb(p_0, view_0);
        this.vdb_1 = view_0;
        view_0.eb7(0.0);
        $this$with.fbb(p_0, view_0);
        $this$with.jbb(tmp_0, view_0);
        this.wdb_1 = RawReactive().yah(_ReactiveState___init__impl__fvdp9b(null));
        var tmp_1 = this;
        var tmp0 = this.vdb_1;
        var tmp_2 = KMutableProperty0();
        var tmp_3 = ActivityIndicator$_get_shown_$ref_61t2d1(tmp0);
        tmp_1.xdb_1 = getPropertyCallableRef('shown', 0, tmp_2, tmp_3, ActivityIndicator$_set_shown_$ref_zcnirl(tmp0));
      }
      aba() {
        return this.odb_1;
      }
      ea2() {
        return this.odb_1.ea2();
      }
      ydb(value) {
        this.pdb_1 = value;
        if (this.sdb_1) {
          afterTimeout(this, 10n, () => {
            this.nas();
            return Unit_instance;
          });
        }
      }
      oda(value) {
        var tmp0_safe_receiver = this.pdb_1;
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.ndb(listOfNotNull(value));
        this.ydb(tmp1_elvis_lhs == null ? new (Info())(listOfNotNull(value), ImageScaleType_Fit_getInstance(), null) : tmp1_elvis_lhs);
      }
      i2i() {
        var tmp0_safe_receiver = this.pdb_1;
        var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.kdb_1;
        return tmp1_safe_receiver == null ? null : firstOrNull(tmp1_safe_receiver);
      }
      pda(value) {
        var tmp0_safe_receiver = this.pdb_1;
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.ndb(VOID, value);
        var tmp;
        if (tmp1_elvis_lhs == null) {
          // Inline function 'kotlin.collections.listOf' call
          var tmp$ret$0 = emptyList();
          tmp = new (Info())(tmp$ret$0, value, null);
        } else {
          tmp = tmp1_elvis_lhs;
        }
        this.ydb(tmp);
      }
      zba() {
        this.sdb_1 = true;
        this.nas();
      }
      nas() {
        if (!this.sdb_1)
          return Unit_instance;
        var info = this.pdb_1;
        if (!equals(this.tdb_1, info)) {
          var tmp0_safe_receiver = this.udb_1;
          if (tmp0_safe_receiver == null)
            null;
          else {
            // Inline function 'kotlin.collections.forEach' call
            var _iterator__ex2g4s = tmp0_safe_receiver.m1();
            while (_iterator__ex2g4s.n1()) {
              var element = _iterator__ex2g4s.o1();
              element.eb7(0.0);
              var tmp = _Duration___get_inWholeMilliseconds__impl__msfiry(element.kba().tb0_1);
              afterTimeout(this, tmp, ZoomableImageView$refresh$lambda(this, element));
            }
          }
          this.wdb_1.pah(Companion_getInstance().mah_1);
          this.tdb_1 = info;
          this.vdb_1.eb7(1.0);
          var tmp_0 = this;
          var tmp_1;
          if (info == null) {
            tmp_1 = null;
          } else {
            // Inline function 'kotlin.let' call
            // Inline function 'kotlin.collections.buildList' call
            // Inline function 'kotlin.collections.buildListInternal' call
            // Inline function 'kotlin.apply' call
            var this_0 = ArrayList().w();
            // Inline function 'kotlin.with' call
            var $this$with = this.odb_1;
            var _iterator__ex2g4s_0 = info.kdb_1.m1();
            while (_iterator__ex2g4s_0.n1()) {
              var imageSource = _iterator__ex2g4s_0.o1();
              var tmp0_elvis_lhs = info.mdb_1;
              var tmp4 = tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
              // Inline function 'com.lightningkite.kiteui.views.direct.rawImageZoomable' call
              var scaleType = info.ldb_1;
              // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
              var view = new (RawImageViewZoomable())($this$with.pc(), imageSource, tmp4, scaleType);
              var tmp0_elvis_lhs_0 = $this$with.cbb_1;
              var p = tmp0_elvis_lhs_0 == null ? $this$with : tmp0_elvis_lhs_0;
              $this$with.ebb(p, view);
              view.eb7(0.0);
              reactive(view, ZoomableImageView$refresh$lambda_0(view, this, info));
              $this$with.fbb(p, view);
              this_0.v(view);
            }
            tmp_1 = this_0.c8();
          }
          var tmp2_elvis_lhs = tmp_1;
          var tmp_2;
          if (tmp2_elvis_lhs == null) {
            // Inline function 'kotlin.run' call
            this.wdb_1.pah(_ReactiveState___init__impl__fvdp9b(null));
            this.vdb_1.eb7(0.0);
            tmp_2 = null;
          } else {
            tmp_2 = tmp2_elvis_lhs;
          }
          tmp_0.udb_1 = tmp_2;
        }
      }
    }
    initMetadataForClass($, 'ZoomableImageView', VOID, VOID, [CoroutineScope()]);
    ZoomableImageViewClass = $;
  }
  return ZoomableImageViewClass;
}
//region block: exports
export {
  ZoomableImageView as ZoomableImageView2th1eo3ejqzvg,
};
//endregion

//# sourceMappingURL=ZoomableImageView.mjs.map
